<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
        style="padding: 25px;"
    >
        <div
            class="last-message"
            style="position:relative;margin:auto;margin-top:100px;font-size:16px;vertical-align:middle;z-index:0;border-radius: 15px;background-color: rgba(0,25,68,0.1);width:100%;max-width:800px;height:auto;"
        >
            <div
                v-if="$route.query.outage"
                style="width:100%;padding: 25px;display: flex;align-items: center;"
            >
                <v-icon
                    color="warning"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-alert-rhombus
                </v-icon>
                <div
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    <span style="font-size:24px;"><b>Awaiting Signature</b></span><br />
                    Electronic signatures are temporarily unavailable.<br />We'll email you when your document is ready to sign.
                </div>
            </div>
            <div
                v-else-if="$route.query.signed == 0"
                style="width:100%;padding: 25px;display: flex;align-items: center;"
            >
                <v-icon
                    color="#262626"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-signature
                </v-icon>
                <div
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    <span style="font-size:24px;"><b>Awaiting Signature</b></span><br />
                    This form is still awaiting your signature. If you need to make corrections, please contact <span class="legalFoot"></span> for assistance.<br />
                    <v-btn
                        color="primary"
                        style="margin:0;margin-top: 10px;"
                        small
                        @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: $route.params.form_id } })"
                    >
                        Sign Now
                    </v-btn>
                </div>
            </div>
            <div
                v-else-if="$route.query.signed == 2"
                style="width:100%;padding: 25px;display: flex;align-items: center;"
            >
                <v-icon
                    color="error"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-file-alert
                </v-icon>
                <div
                    v-if="$route.query.message"
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    {{ $route.query.message }}
                </div>
                <div
                    v-else
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    <span style="font-size:24px;"><b>Try again later</b></span><br />
                    An error occured when trying to request your signature. Please try again later.<br />
                    <i>Your answers were saved.</i>
                </div>
            </div>
            <div
                v-else-if="$route.query.signed == 3"
                style="width:100%;padding: 25px;display: flex;align-items: center;"
            >
                <v-icon
                    color="error"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-hexagon-slice-6
                </v-icon>
                <div
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    <span style="font-size:24px;"><b>You declined to sign</b></span><br />
                    This form is not complete without your signature. Please contact <span class="legalFoot"></span> if you require assistance.
                </div>
            </div>
            <div
                v-else-if="$route.query.signed == 4"
                style="width:100%;padding: 25px;display: flex;align-items: center;"
            >
                <v-icon
                    color="#262626"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-email-fast
                </v-icon>
                <div
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    <span style="font-size:24px;"><b>Time to Sign</b></span><br />
                    You're almost done with this form - you just need to sign it. Please check your email for a link to sign this form.<br /><br />Any additional signers will also receive an email to sign.
                </div>
            </div>
            <div
                v-else
                style="width:100%;padding: 25px;display: flex;align-items: center;"
            >
                <v-icon
                    color="green"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-check-circle
                </v-icon>
                <div
                    v-if="$route.query.message"
                    style="padding: 10px;margin-top: 15px;background: rgba(0,25,68,0.1);border-radius: 15px;"
                >
                    {{ $route.query.message }}
                </div>
                <div
                    v-else
                    style="display:inline-block;width: calc(100% - 87px);"
                >
                    <span style="font-size:24px;"><b>Submitted</b></span><br />
                    Your form has been submitted. Please contact us if you need to make any changes to your answers.<br />                    
                </div>
            </div>
        </div>
        <div
            style="max-width: 800px;margin:auto;margin-top: 55px;"
        >
            <v-card
                v-if="availableForms.length > 0"
                style="margin-top: 20px;"
            >
                <v-toolbar
                    flat
                >
                    <b>Other Forms Requiring Your Attention</b>
                </v-toolbar>
                <v-card-text>
                    <v-layout
                        v-if="availableForms.length > 0"
                        row
                        wrap
                    >
                        <v-flex
                            v-for="form in availableForms"
                            :key="form.id"
                            xs12
                            class="standard-form-card"
                            :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                        >
                            <v-card    
                                class="form-card"
                                style="cursor:pointer;"
                                @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                            >
                                <v-card-text
                                    style="border-bottom: 1px solid rgba(0,0,0,0.1);"
                                >
                                    <div
                                        style="font-size: 16px;font-weight: bold;"
                                    >
                                        {{form.name}}
                                    </div>
                                    <div>
                                        {{ convertToLocal(form.created_at) }}
                                    </div>
                                    <br />
                                    <span
                                        v-if="form.party_name"
                                        style="font-weight: bold;"
                                    >
                                        {{form.party_name}}
                                    </span>
                                    <span
                                        v-if="form.form_number"
                                        style="font-style: italic;"
                                    >
                                        ({{form.form_number}})
                                    </span>
                                </v-card-text>
                                <v-card-text
                                    v-if="!form.is_new"
                                    style="padding-top: 5px;padding-bottom:5px;"
                                >
                                    <div
                                        style="font-size: 12px;"
                                    >
                                        <b>Last Updated: </b> {{convertToCalRef(form.updated_at)}}
                                    </div>
                                </v-card-text>
                                <v-card-actions
                                    style="background: rgba(0,0,0,0.15);border-top: 1px solid rgba(0,0,0,0.1);"
                                >
                                    <v-spacer />
                                    <v-btn
                                        v-if="form.is_signing"
                                        color="warning"
                                    >
                                        Sign Form
                                    </v-btn>
                                    <v-btn
                                        v-else-if="form.is_new"
                                        color="green"
                                        dark
                                    >
                                        Start Form
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        color="primary"
                                    >
                                        Open Form
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-card
                v-else
                style="margin-top: 20px;"
            >
                <v-card-text
                    style="text-align:center;"
                >
                    <h3>
                        You have no other forms that require your attention.
                    </h3>
                </v-card-text>
            </v-card>
            <v-card
                elevation="0"
                style="margin-top: 25px;"
            >
                <v-card-actions>
                    <v-btn
                        color="primary"
                        :to="{name: 'Home'}"
                    >
                        Go Home
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        flat
                        color="primary"
                        :to="{name: 'Forms', params: { id: $route.params.id }}"
                    >
                        Forms
                    </v-btn>
                    <v-btn
                        flat
                        color="primary"
                        :to="{name: 'Messages'}"
                    >
                        Messages
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'UserFormSubmitted',
    data () {
        return {
            forms: [],
            loading: false
        }
    },
    created () {
        this.fetchForms()
    },
    methods: {
        fetchForms () {
            this.loading = true
            api.userform.contactUserForm.list({ count: 25 })
                .then(data => {
                    this.forms = data.results
                })
        },
    },
    computed: {
        ...mapGetters('userform', [
            'localCacheSignedForms',
        ]),
        availableForms () {
            var forms = []
            var count = 0
            this.forms.forEach((form) => {
                if (this.localCacheSignedForms.includes(form.id))
                    return
                if (form.id == this.$route.params.id)
                    return
                if (count == 3)
                    return
                if (!form.client_readonly || form.is_signing) {
                    forms.push(form)
                    count++
                }
            })
            return forms
        },
    }
}
</script>


<style scoped>
    .standard-content {
        max-height: calc(100vh);
        height:100%;
        overflow-y:auto;
        position: relative;
    }
    .mobile-content {
        max-height: calc(100vh - 56px - var(--mobile-padding-bottom, 0px)) !important;
        position: relative;
    }

    .form-card {
        position: relative;
    }

    .standard-form-card {
        padding-right: 15px;
        padding-top: 15px;
    }

    .mobile-form-card {
        padding-top: 15px;
        padding-right: 0 !important;
    }
</style>